import { render } from "./KSSettingCluster.vue?vue&type=template&id=190fce89&scoped=true"
import script from "./KSSettingCluster.vue?vue&type=script&lang=js"
export * from "./KSSettingCluster.vue?vue&type=script&lang=js"

import "./KSSettingCluster.vue?vue&type=style&index=0&id=190fce89&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190fce89"]])

export default __exports__